module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product.description.trim().length) ? _c('div', {
    staticClass: "builder__description",
    class: _vm.responsiveCssClasses
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "builder__description-content",
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  })]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "builder__description-heading"
  }, [_c('h2', [_vm._v("Product Description")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68999520"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Description.vue
// module id = 373
// module chunks = 0